import { FC } from 'react';

import { Grid } from '@mui/material';

import { navigate, routes } from '@redwoodjs/router';

import TableList from 'src/components/TableList/TableList';
import { SERVICES_TABLE_HEADERS } from 'src/constants';
import { ROLE_PERMISSIONS } from 'src/constants/role-permissions';
interface ServiceProps {
    services: {
        id: number;
        tradingName: string;
        serviceType: string;
        product: string;
        createdAt: string;
        status: string;
        contractExpiry: string;
        promosText: string;
        promoExpiryDate: Date | null;
    }[];
    merchantId: number;
}
const Service: FC<ServiceProps> = ({ services, merchantId }) => {
    const tableData = services.map((service) => {
        return {
            ...service,
            dateAdded: service.createdAt,
            promosText: service.promosText,
            promoExpiryDate: service.promoExpiryDate
                ? new Date(service.promoExpiryDate).toISOString()
                : '-',
        };
    });

    return (
        <Grid
            sx={{
                display: 'flex',
                flexDirection: 'column',
                maxWidth: '100%',
                width: '100%',
            }}
        >
            <TableList
                data={tableData}
                headers={SERVICES_TABLE_HEADERS}
                addRecordButtonText="Add Application"
                addRecordSecondButtonText="Add Service"
                hasAddRecordSecondButtonPermission={ROLE_PERMISSIONS.addService}
                title="Roles List"
                addRecordCallBack={() => {}}
                addSecondRecordCallBack={() => {
                    navigate(routes.AddService({ merchantId }));
                }}
                handleViewRecord={() => {}}
                deleteRecordCallBack={() => {}}
                enableFilter
                filterOptions={{}}
                handleCellClick={() => {}}
            />
        </Grid>
    );
};

export default Service;
